"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginAction = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var utils_1 = require("@dp-instant/utils");
var inversify_1 = require("inversify");
var AppModel_1 = require("../model/AppModel");
var LoginAction = (function (_super) {
    tslib_1.__extends(LoginAction, _super);
    function LoginAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginAction.prototype.execute = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var firebase;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        firebase = this.gameConfig.firebase;
                        if (!firebase) return [3, 2];
                        return [4, this.model.init({
                                appId: this.gameConfig.id,
                                firebase: firebase,
                                host: (_a = this.gameConfig.backend) === null || _a === void 0 ? void 0 : _a.host,
                                provider: this.social.socialPlatform
                            })];
                    case 1:
                        _b.sent();
                        return [3, 3];
                    case 2:
                        utils_1.log.warn("Firebase analytics is not configured");
                        return [2];
                    case 3:
                        this.trackEntryPoint();
                        (0, core_1.lazyRun)(interfaces_1.TypesApp.authAction);
                        return [2];
                }
            });
        });
    };
    LoginAction.prototype.trackEntryPoint = function (entry) {
        var tracker = (0, core_1.lazyGet)(interfaces_1.TypesAnalytics.tracker);
        if (entry && entry.ref) {
            var entryEvent = "game_entry_" + entry.ref.source;
            this.social.session.ftue
                ? tracker.track("ftue_".concat(entryEvent), entry.ref)
                : tracker.track(entryEvent, entry.ref);
        }
        else {
            this.social.session.ftue
                ? tracker.track("ftue_game_entry")
                : tracker.track("game_entry");
        }
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesApp.model),
        tslib_1.__metadata("design:type", AppModel_1.AppModel)
    ], LoginAction.prototype, "model", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.model),
        tslib_1.__metadata("design:type", Object)
    ], LoginAction.prototype, "social", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesCore.gameConfig),
        tslib_1.__metadata("design:type", Object)
    ], LoginAction.prototype, "gameConfig", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesAnalytics.tracker),
        tslib_1.__metadata("design:type", Object)
    ], LoginAction.prototype, "analytics", void 0);
    LoginAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], LoginAction);
    return LoginAction;
}(core_1.Action));
exports.LoginAction = LoginAction;
//# sourceMappingURL=LoginAction.js.map